import Choices from 'choices.js'

// Remove preload class on load
window.addEventListener('load', () => {
    const form = document.querySelector("[data-form='register']");

    if (form) {
        const checkBoxInvoice = form.querySelector(`[data-form-input="invoice"] input`) as any
        const fromInvoiceGroup = form.querySelectorAll(`[data-invoice-option]`);


        const showInputs = (fromInvoiceGroup: any) => {
            fromInvoiceGroup.forEach((item: any) => {
                const input = item.querySelector('input');

                item.classList.remove('hide');
                item.classList.add('required');

                if (input) {
                    input.setAttribute('required', 'true');
                    input.setAttribute('aria-required', 'true');
                    input.setAttribute('aria-invalid', 'true');
                }
            })
        }

        const hideInputs = (fromInvoiceGroup: any) => {
            fromInvoiceGroup.forEach((item: any) => {
                const input = item.querySelector('input');

                item.classList.add('hide');
                item.classList.remove('required');
                if (input) {
                    input.removeAttribute('required');
                    input.removeAttribute('aria-required');
                    input.removeAttribute('aria-invalid');
                }
            })
        }

        if (checkBoxInvoice) {
            checkBoxInvoice.addEventListener('click', () => {

                if (checkBoxInvoice.checked == true) {
                    showInputs(fromInvoiceGroup)
                } else {
                    hideInputs(fromInvoiceGroup)
                }
            })
        }



    }

    const selects = document.querySelectorAll(`[data-item="select"]`)
    if (selects.length > 0) {
        selects.forEach((select) => {
            const choices = new Choices(select, {
                allowHTML: true,
            })
        })
    }

    const selects2 = document.querySelectorAll(`[data-item="select2"]`)
    if (selects2.length > 0) {
        selects2.forEach((select) => {
            const choices = new Choices(select, {
                allowHTML: true,
            })

            select.addEventListener(
                'change',
                function (event) {

                    if (event.currentTarget && event.currentTarget.selectedOptions[0]) {
                        const option = event.currentTarget.selectedOptions[0].getAttribute('data-custom-properties');

                        if (form) {
                            const from_group = form.querySelectorAll(`[data-group-option]`);

                            from_group.forEach((item) => {
                                const input = item.querySelector('input');

                                if (item.getAttribute('data-group-option') === option) {
                                    item.classList.remove('hide');
                                    item.classList.add('required');

                                    if (input) {
                                        input.setAttribute('required', 'true');
                                        input.setAttribute('aria-required', 'true');
                                        input.setAttribute('aria-invalid', 'true');
                                    }
                                } else {
                                    item.classList.add('hide');
                                    item.classList.remove('required');
                                    if (input) {
                                        input.removeAttribute('required');
                                        input.removeAttribute('aria-required');
                                        input.removeAttribute('aria-invalid');
                                    }
                                }
                            })
                        }

                    }
                },
                false,
            );
        })
    }
})